// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
  apiKey: "AIzaSyC3LVlKxtrGP5Xtvoq-aWBm6psxDdizf3Y",
  authDomain: "nda-school.firebaseapp.com",
  projectId: "nda-school",
  storageBucket: "nda-school.firebasestorage.app",
  messagingSenderId: "788330694710",
  appId: "1:788330694710:web:aae6d55f6e9644ab44b097",
  measurementId: "G-1TKE7FMMFM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore();
const storage = getStorage(app);

export {app};
export {firebaseConfig};
export {analytics}
export {db}
export {storage}
